import React from "react";
import paragraphs from "./platform-user-agreement-en.json";

const isSectionHeading = text =>
    text === "Definitions" ||
    text === "Translator's Notes" ||
    /^(?:[2-9]|1\d|2[01])\s/.test(text);

export default function EnglishPlatformUserAgreement() {
    const [title, ...body] = paragraphs;

    return (
        <div className="mypageContents aboutContents">
            <div className="mypageContents__inner2">
                <header className="mainHeading">
                    <h1 className="mainHeading__title">{title}</h1>
                </header>
                <div className="aboutBox">
                    <div className="aboutBox__inner">
                        {body.map((text, index) =>
                            isSectionHeading(text) ? (
                                <h3 className="termsof__item__title" key={index}>
                                    {text}
                                </h3>
                            ) : (
                                <p key={index}>{text}</p>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
